// repos/storyRepo.js
import { db } from '@/db/db';

export const storyRepo = {
  // 오늘자(category+date) 캐시 조회
  async listByCategoryAndDate(categoryId, dayStr) {
    return db.story
      .where('[category_idx+update_date]')
      .equals([categoryId, dayStr])
      .toArray();
  },

  // 오늘자(category) 데이터만 교체 (지우고 새로 넣기)
  async replaceCategoryForDate(categoryId, dayStr, rows) {
    return db.transaction('rw', db.story, async () => {
      await db.story
        .where('[category_idx+update_date]')
        .equals([categoryId, dayStr])
        .delete();                              // ← 카테고리+오늘자만 삭제

      await db.story.bulkPut(rows);             // ← 한 번에 저장
    });
  },

  // 카테고리 전체 삭제(원하면 사용)
  async deleteByCategory(categoryId) {
    return db.story.where('category_idx').equals(categoryId).delete();
  }
};